<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container [formGroup]="accountInformations">
      <div class="row">
        <div class="col-md-12">
          <pr-input-radio
            [derrors]="derrors"
            formControlName="realEstateKnowledgeLevel"
            direction="column"
            [isDefault]="false"
            columns="4"
            [options]="knowledgeFinancialAssetsOptions"
            label="Quelle est votre connaissance des marchés immobiliers ?"
          >
          </pr-input-radio>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <pr-input-radio
            formControlName="hasInvestScpi"
            columns="3"
            [toggle]="true"
            [isDefault]="false"
            label="Avez-vous déjà investi en SCPI dans le passé ?"
          >
          </pr-input-radio>
        </div>

        <div class="col-md-6">
          <pr-input-column
            [hidden]="!accountInformations.get('hasInvestScpi')?.value"
            label="Montant investi en SCPI"
          >
            <input formControlName="amountInvestScpi" type="number" />
          </pr-input-column>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <pr-input-radio
            [derrors]="derrors"
            formControlName="frequencyInvestScpi"
            direction="column"
            [isDefault]="false"
            columns="4"
            [options]="frequencyFinancialTransactionsOptions"
            label="Fréquence moyenne de vos transactions en SCPI"
          >
          </pr-input-radio>
        </div>

        <div class="col-md-12">
          <pr-input-column
            label="Nombre de transactions en SCPI sur les 12 derniers mois"
            [derrors]="derrors"
            [isDefault]="false"
          >
            <input formControlName="numberScpiInvestLastYear" type="number" />
          </pr-input-column>
        </div>
      </div>
      <!-- Assurance-vie -->
      <div class="row">
        <div class="col-md-6">
          <pr-input-radio
            formControlName="hasInvestLifeInsurance"
            columns="3"
            [toggle]="true"
            [isDefault]="false"
            label="Avez-vous déjà investi en Assurance-vie dans le passé ?"
          >
          </pr-input-radio>
        </div>

        <div class="col-md-6">
          <pr-input-column
            [hidden]="
              !accountInformations?.get('hasInvestLifeInsurance')?.value
            "
            label="Montant investi en Assurance-vie"
          >
            <input formControlName="amountInvestLifeInsurance" type="number" />
          </pr-input-column>
        </div>
      </div>
      <!-- Girardin -->
      <div class="row">
        <div class="col-md-6">
          <pr-input-radio
            formControlName="hasInvestGirardin"
            columns="3"
            [toggle]="true"
            [isDefault]="false"
            label="Avez-vous déjà investi en Girardin par le passé ?"
          >
          </pr-input-radio>
        </div>

        <div class="col-md-6">
          <pr-input-column
            [hidden]="!accountInformations?.get('hasInvestGirardin')?.value"
            [isDefault]="false"
            label="Montant investi en Girardin"
          >
            <input formControlName="amountInvestGirardin" type="number" />
          </pr-input-column>
        </div>
      </div>
      <!-- Crowdfunding -->
      <div class="row">
        <div class="col-md-6">
          <pr-input-radio
            formControlName="hasInvestCrowdfunding"
            columns="3"
            [toggle]="true"
            [isDefault]="false"
            label="Avez-vous déjà investi en Crowdfunding par le passé ?"
          >
          </pr-input-radio>
        </div>

        <div class="col-md-6">
          <pr-input-column
            [hidden]="!accountInformations?.get('hasInvestCrowdfunding')?.value"
            [isDefault]="false"
            label="Montant investi en Crowdfunding"
          >
            <input formControlName="amountInvestCrowdfunding" type="number" />
          </pr-input-column>
        </div>
      </div>
      <!-- OCP Business -->
      <div class="row">
        <div class="col-md-6">
          <pr-input-radio
            formControlName="hasInvestOcpBusinessCenter"
            columns="3"
            [toggle]="true"
            [isDefault]="false"
            label="Avez-vous déjà investi en OCP Business Center par le passé ?"
          >
          </pr-input-radio>
        </div>

        <div class="col-md-6">
          <pr-input-column
            [hidden]="
              !accountInformations?.get('hasInvestOcpBusinessCenter')?.value
            "
            [isDefault]="false"
            label="Montant investi en OCP Business Center"
          >
            <input
              formControlName="amountInvestOcpBusinessCenter"
              type="number"
            />
          </pr-input-column>
        </div>
      </div>

      <!-- OCP Club Deal -->
      <div class="row">
        <div class="col-md-6">
          <pr-input-radio
            formControlName="hasInvestOcpClubDeal"
            columns="3"
            [toggle]="true"
            [isDefault]="false"
            label="Avez-vous déjà investi en OCP Club Deal par le passé ?"
          >
          </pr-input-radio>
        </div>

        <div class="col-md-6">
          <pr-input-column
            [hidden]="!accountInformations?.get('hasInvestOcpClubDeal')?.value"
            [isDefault]="false"
            label="Montant investi en OCP Club Deal"
          >
            <input formControlName="amountInvestOcpClubDeal" type="number" />
          </pr-input-column>
        </div>
      </div>

      <!-- FIP -->
      <div class="row">
        <div class="col-md-6">
          <pr-input-radio
            formControlName="hasInvestFip"
            columns="3"
            [toggle]="true"
            [isDefault]="false"
            label="Avez-vous déjà investi en FIP par le passé ?"
          >
          </pr-input-radio>
        </div>

        <div class="col-md-6">
          <pr-input-column
            [hidden]="!accountInformations.get('hasInvestFip')?.value"
            [isDefault]="false"
            label="Montant investi en FIP"
          >
            <input formControlName="amountInvestFip" type="number" />
          </pr-input-column>
        </div>
      </div>

      <!-- FCPI -->
      <div class="row">
        <div class="col-md-6">
          <pr-input-radio
            formControlName="hasInvestFcpi"
            columns="3"
            [toggle]="true"
            [isDefault]="false"
            label="Avez-vous déjà investi en FCPI par le passé ?"
          >
          </pr-input-radio>
        </div>

        <div class="col-md-6">
          <pr-input-column
            [hidden]="!accountInformations.get('hasInvestFcpi')?.value"
            [isDefault]="false"
            label="Montant investi en FCPI"
          >
            <input formControlName="amountInvestFcpi" type="number" />
          </pr-input-column>
        </div>
      </div>

      <!-- PEA -->
      <div class="row">
        <div class="col-md-6">
          <pr-input-radio
            formControlName="hasPeaInvestmentSupport"
            columns="3"
            [toggle]="true"
            [isDefault]="false"
            label="Avez-vous déjà investi en PEA capitalisation par le passé ?"
          >
          </pr-input-radio>
        </div>
      </div>
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
